/**
 * checks if the current user in in the Bahrain region (based on the current URL) in order to surmise if it is a Samoon user
 * (since we currently have zero other indication aside from that)
 * @returns boolean
 */
export const isSamoon = (): boolean => {
  // ? because TS complains for seemingly no reason that the return is a string type and is as compact as a forced conversion would be
  return window.location && window.location.origin && window.location.origin.includes(".bh.") ? true : false;
};
